<template>
    <div id="editQuestionLoadingDiv" class="vs-con-loading__container">
        <vs-alert color="danger" title="Requested Question Not Found" :active.sync="question_not_found">
            <span>Question record with id: {{ $route.params.questionId }} not found. </span>
            <span>
                <span>Check </span><router-link :to="{name:'questions'}" class="text-inherit underline">All Questions</router-link>
            </span>
        </vs-alert>

        <div id="module-data" v-if="question_data">
            <vx-card title="" class="mb-base" style="min-height: 600px;">
                <form data-vv-scope="editQuestionForm">
                    <div class="vx-row mb-base">
                      <div class="vx-col w-6/12">
                        <div class="flex items-start flex-col sm:flex-row">
                          <img height="300px" :src="question_data.picture" class="mr-8 rounded" />
                        </div>
                      </div>

                      <div class="vx-col w-6/12 mb-2">
                        Language
                         <vs-switch class="w-2/12" color="success" v-model="lang">
                            <span slot="on">English</span>
                            <span slot="off">Danish</span>
                        </vs-switch>
                      </div>
                    </div>

                    <vs-divider/>

                    <div class="vx-row mb-base">
                        <div class="vx-col sm:w-3/4">
                            Situation<br>
                            <span>{{question_data.situation}}</span>
                        </div>
                        <div class="vx-col sm:w-1/4" v-if="question_data.situation_audio">
                            <audio-player
                              ref="audioPlayer"
                              :show-playback-rate="false"
                              :isLoop="false"
                              :audio-list="[question_data.situation_audio]"
                              theme-color="#00A99D"
                            />
                        </div>
                    </div>

                    <vs-divider position="left"> Question 1 </vs-divider>

                    <div class="vx-row mt-4 mx-2">
                        <div class="vx-col sm:w-5/12">
                            <span>{{question_data.q1}}</span>
                        </div>
                        <div class="vx-col sm:w-2/12">
                            <vs-switch readonly="true" color="success" v-model="a1">
                                <span slot="on">Yes</span>
                                <span slot="off">No</span>
                            </vs-switch>
                        </div>
                        <div class="vx-col sm:w-2/12">
                        </div>
                        <div class="vx-col sm:w-3/12" v-if="question_data.q1_audio">
                            <audio-player
                              ref="audioPlayer"
                              :show-playback-rate="false"
                              :isLoop="false"
                              :audio-list="[question_data.q1_audio]"
                              theme-color="#00A99D"
                            />
                        </div>
                    </div>
                    <div class="vx-row mx-2">
                        <div class="vx-col sm:w-full">
                            <span v-html="question_data.q1_explanation"></span>
                        </div>
                    </div>

                    <vs-divider position="left"> Question 2 </vs-divider>

                    <div class="vx-row mt-4 mx-2">
                        <div class="vx-col sm:w-5/12">
                            <span>{{question_data.q2}}</span>
                        </div>
                        <div class="vx-col sm:w-2/12">
                            <vs-switch readonly="true" color="success" v-model="a2">
                                <span slot="on">Yes</span>
                                <span slot="off">No</span>
                            </vs-switch>
                        </div>
                        <div class="vx-col sm:w-2/12">
                        </div>
                        <div class="vx-col sm:w-3/12" v-if="question_data.q2_audio">
                            <audio-player
                              ref="audioPlayer"
                              :show-playback-rate="false"
                              :isLoop="false"
                              :audio-list="[question_data.q2_audio]"
                              theme-color="#00A99D"
                            />
                        </div>
                    </div>
                    <div class="vx-row mx-2">
                        <div class="vx-col sm:w-full">
                            <span v-html="question_data.q2_explanation"></span>
                        </div>
                    </div>

                    <vs-divider position="left"> Question 3 </vs-divider>

                    <div class="vx-row mt-4 mx-2">
                        <div class="vx-col sm:w-5/12">
                            <span>{{question_data.q3}}</span>
                        </div>
                        <div class="vx-col sm:w-2/12">
                            <vs-switch readonly="true" color="success" v-model="a3">
                                <span slot="on">Yes</span>
                                <span slot="off">No</span>
                            </vs-switch>
                        </div>
                        <div class="vx-col sm:w-2/12">
                        </div>
                        <div class="vx-col sm:w-3/12" v-if="question_data.q3_audio">
                            <audio-player
                              ref="audioPlayer"
                              :show-playback-rate="false"
                              :isLoop="false"
                              :audio-list="[question_data.q3_audio]"
                              theme-color="#00A99D"
                            />
                        </div>
                    </div>
                    <div class="vx-row mx-2">
                        <div class="vx-col sm:w-full">
                            <span v-html="question_data.q3_explanation"></span>
                        </div>
                    </div>

                    <vs-divider position="left"> Question 4 </vs-divider>

                    <div class="vx-row mt-4 mx-2">
                        <div class="vx-col sm:w-5/12">
                            <span>{{question_data.q4}}</span>
                        </div>
                        <div class="vx-col sm:w-2/12">
                            <vs-switch readonly="true" color="success" v-model="a4">
                                <span slot="on">Yes</span>
                                <span slot="off">No</span>
                            </vs-switch>
                        </div>
                        <div class="vx-col sm:w-2/12">
                        </div>
                        <div class="vx-col sm:w-3/12" v-if="question_data.q4_audio">
                            <audio-player
                              ref="audioPlayer"
                              :show-playback-rate="false"
                              :isLoop="false"
                              :audio-list="[question_data.q4_audio]"
                              theme-color="#00A99D"
                            />
                        </div>
                    </div>
                    <div class="vx-row mx-2">
                        <div class="vx-col sm:w-full">
                            <span v-html="question_data.q4_explanation"></span>
                        </div>
                    </div>

                    <vs-divider/>

                    <div class="vx-row mt-base">
                        <div class="vx-col w-full"  align="right">
                          <vs-button @click="editQuestion()" class="mr-3 mb-2">Edit Question</vs-button>
                        </div>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
</template>

<script>
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'

export default{
    data() {
        return {
            question_data: null,
            question_not_found: false,
        }
    },
    components: {

    },
    computed: {
        lang: {
            set: function(val) {
                // this.question_data.lang = val ? "en" : "da";
            },
            get: function() {
                return this.question_data.lang == "en" ? true : false;
            }
        },
        a1: {
            set: function(val) {
                // this.question_data.a1 = val ? "true" : "false";
            },
            get: function() {
                return this.question_data.a1 == "true" ? true : false;
            }
        },
        a2: {
            set: function(val) {
                // this.question_data.a2 = val ? "true" : "false";
            },
            get: function() {
                return this.question_data.a2 == "true" ? true : false;
            }
        },
        a3: {
            set: function(val) {
                // this.question_data.a3 = val ? "true" : "false";
            },
            get: function() {
                return this.question_data.a3 == "true" ? true : false;
            }
        },
        a4: {
            set: function(val) {
                // this.question_data.a4 = val ? "true" : "false";
            },
            get: function() {
                return this.question_data.a4 == "true" ? true : false;
            }
        },
    },
    methods: {
        editQuestion() {
            this.$router.push("/questions/edit/" + this.question_data.id).catch(() => {})
        },
    },
    mounted(){
        this.$vs.loading({
            container: '#editQuestionLoadingDiv',
            scale: 0.6
        })

        const questionId = this.$route.params.questionId
        this.$store.dispatch("questionManagement/viewQuestion", questionId)
            .then(res => { 
                this.question_data = res.data 
                this.$vs.loading.close('#editQuestionLoadingDiv > .con-vs-loading')

            })
            .catch(err => {
                this.question_not_found = true
                this.$vs.loading.close('#editQuestionLoadingDiv > .con-vs-loading')
            })

    },
    created() {
        if(!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }
    },

}
</script>

